import React, { useCallback, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import AdminDashboard from "../components/AdminDashboard";
import {
  buildAdminDashboardPath,
  getDefaultDashboardTabForRole,
  isDashboardShellPath,
  LIVE_MAP_PATH,
  readDashboardTabFromSearch,
  resolveDashboardTabFromPath,
} from "./dashboardNavigation";

export default function AdminDashboardRoutePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentUser = useSelector((state) => state.auth.user);
  const shouldRenderDashboardShell = isDashboardShellPath(location.pathname);

  const fallbackTab = useMemo(
    () => getDefaultDashboardTabForRole(currentUser?.role),
    [currentUser?.role]
  );

  const activeTab = useMemo(
    () =>
      location.pathname === LIVE_MAP_PATH
        ? "map"
        : resolveDashboardTabFromPath(
            location.pathname,
            readDashboardTabFromSearch(location.search, fallbackTab)
          ),
    [fallbackTab, location.pathname, location.search]
  );

  const setActiveTab = useCallback(
    (nextTab) => {
      const params = new URLSearchParams(location.search);
      navigate(
        buildAdminDashboardPath({
          tab: nextTab,
          mapStatusFilter: params.get("status"),
          navToken: params.get("nav"),
        })
      );
    },
    [location.search, navigate]
  );

  if (!shouldRenderDashboardShell) {
    return null;
  }

  return (
    <AdminDashboard
      key={`${location.pathname}${location.search}`}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
    />
  );
}
